module.exports = __webpack_public_path__ + "img/biride.20f29b8e.png";